import { FieldAPIClient } from 'module/api/field';
import { axiosInstance } from 'api/axios';

export const FieldAPI = new FieldAPIClient(axiosInstance);
